import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../i18n";
import api from "../api";

const Pricing = () => {
  const { t, lang } = useI18n();
  const [packages, setPackages] = useState([]);

  useEffect(() => {
    api.get("/catalog/pricing").then((r) => setPackages(r.data.packages));
  }, []);

  return (
    <div className="max-w-4xl mx-auto px-4 md:px-8 py-12">
      <div className="flex items-center gap-3 mb-3">
        <div className="font-mono text-xs tracking-widest text-[#FF3B30]">// ACCESS</div>
        <span
          className="font-mono text-[10px] tracking-widest px-2 py-1"
          style={{ background: "#FF3B30", color: "white" }}
          data-testid="pilot-badge"
        >
          {lang === "ro" ? "FAZĂ PILOT" : "PILOT PHASE"}
        </span>
      </div>
      <h1 className="font-heading text-4xl md:text-5xl mb-4">
        {lang === "ro" ? "Acces & Tarife" : "Access & Pricing"}
      </h1>
      <p className="text-white/70 mb-2 max-w-2xl">
        {lang === "ro"
          ? "Sports Nutrition Engine este în fază pilot. Tarifele de mai jos sunt indicative pentru utilizare comercială viitoare."
          : "Sports Nutrition Engine is in pilot phase. The pricing below is indicative for future commercial use."}
      </p>
      <p className="text-white/60 mb-10 max-w-2xl text-sm">
        {lang === "ro"
          ? "Acces curent doar pe invitație — contactul cu autorul se face direct, în persoană."
          : "Access is currently invite-only — contact with the author is handled directly, in person."}
      </p>

      <div className="grid md:grid-cols-2 gap-6 mb-10">
        {packages.map((pkg) => (
          <PlanCard key={pkg.key} pkg={pkg} lang={lang} highlight={pkg.key === "plan_1y"} />
        ))}
      </div>

      <div className="sne-card">
        <div className="font-mono text-xs tracking-widest text-white/50 mb-2">
          {lang === "ro" ? "ACCES PILOT" : "PILOT ACCESS"}
        </div>
        <h3 className="font-heading text-2xl mb-3">
          {lang === "ro" ? "Ai primit deja un cod?" : "Already received a code?"}
        </h3>
        <p className="text-sm text-white/70 mb-4">
          {lang === "ro"
            ? "Conectează-te direct cu codul primit de la autor."
            : "Sign in directly with the code provided by the author."}
        </p>
        <Link to="/login" data-testid="pricing-go-login">
          <button className="btn-primary">{t.login.title} →</button>
        </Link>
      </div>

      <div className="mt-6 text-xs text-white/40 font-mono">
        {lang === "ro"
          ? "TRIBOIAI LLC · faza pilot, fără tranzacții active"
          : "TRIBOIAI LLC · pilot phase, no active transactions"}
      </div>
    </div>
  );
};

const PlanCard = ({ pkg, lang, highlight }) => (
  <div className="sne-card flex flex-col relative" style={highlight ? { borderColor: "#FF3B30" } : {}}>
    {highlight && (
      <span className="absolute top-4 right-4 font-mono text-[10px] tracking-widest text-white px-2 py-1" style={{ background: "#FF3B30" }}>
        {lang === "ro" ? "RECOMANDAT" : "BEST VALUE"}
      </span>
    )}
    <div className="font-mono text-xs tracking-widest text-white/50">{pkg[`label_${lang}`] || pkg.label_en}</div>
    <div className="flex items-baseline gap-2 mt-2 mb-3">
      <span className="font-heading text-5xl">€{pkg.amount}</span>
      <span className="font-mono text-xs text-white/40">
        {lang === "ro" ? "(indicativ)" : "(indicative)"}
      </span>
    </div>
    <ul className="text-sm text-white/70 space-y-2 mb-6">
      <li>✓ {pkg.plans_quota} {lang === "ro" ? "planuri generate" : "plan generations"}</li>
      <li>✓ {pkg.duration_days} {lang === "ro" ? "zile valabilitate" : "days validity"}</li>
      <li>✓ {lang === "ro" ? "Multi-device (telefon, PC, tabletă)" : "Multi-device (phone, PC, tablet)"}</li>
      <li>✓ {lang === "ro" ? "Plan săptămânal + Pofte + Check-in" : "Weekly plan + Cravings + Check-in"}</li>
      <li>✓ {lang === "ro" ? "Export PDF final" : "Final PDF export"}</li>
    </ul>
    <div
      className="mt-auto p-3 text-center"
      style={{ background: "#181111", border: "1px dashed #FF3B3050" }}
      data-testid={`pricing-pilot-${pkg.key}`}
    >
      <div className="font-mono text-[10px] tracking-widest text-[#FF6B61]">
        {lang === "ro" ? "FAZĂ PILOT" : "PILOT PHASE"}
      </div>
      <div className="text-xs text-white/70 mt-1">
        {lang === "ro"
          ? "Acces gratuit pe invitație directă"
          : "Free access by direct invitation"}
      </div>
    </div>
  </div>
);

export default Pricing;
